// import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../assets/css/leaves.scss'; // Ensure this path is correct
// import cheverondown from '../../assets/images/Dashboard/chevron-down.svg';
// import { Modal } from 'react-bootstrap';
// import SbCancelBtn, { SBSaveUpdateBtn } from './Buttons';
// import { useDispatch, useSelector } from 'react-redux';
// import { loadComplaintEscalationStatusDropdownData } from '../../redux/action';

// const SbComplaintStatusDropdown = ({ status, onStatusChange, complaintId }) => {
//     // console.log(status,'status')

//     let dispatch = useDispatch();

//     const { complaintEscalationStatusDropdownData } = useSelector((state) => state.data);

//     const [localStatus, setLocalStatus] = useState(status); // Use the prop status as initial value
//     const [showModal, setShowModal] = useState(false);
//     const [action, setAction] = useState(null);
//     const [rejectionReason, setRejectionReason] = useState(''); // State for rejection reason

//     // useEffect(() => {
//     //     if (complaintId) {
//     //         dispatch(loadComplaintEscalationStatusDropdownData(complaintId)); // Dispatch with complaintId
//     //     }
//     // }, [complaintId, dispatch]);

//     const handleClick = () => {
//         if (complaintId) {
//             dispatch(loadComplaintEscalationStatusDropdownData(complaintId)); // Dispatch with complaintId
//         }
//     }

//     // Handle status change and show modal for certain actions
//     const handleStatusChange = (newStatus) => {
//         setAction(newStatus);
//         setShowModal(true);
//     };

//     // Confirm the action and update status
//     const handleConfirm = () => {
//         if (action) {
//             setLocalStatus(action);
//             onStatusChange(action); // Update the parent status
//             setAction(null);
//             setRejectionReason(''); // Reset reason after confirming
//         }
//         setShowModal(false);
//     };

//     // Close the modal without updating status
//     const handleClose = () => {
//         setShowModal(false);
//         setAction(null);
//         setRejectionReason(''); // Reset reason on close
//     };

//     // Determine the button class based on status
//     const getButtonClass = () => {
//         switch (status) {
//             case 'Pending':
//                 return 'status-pending status-btn-pending';
//             case 'In-Process':
//                 return 'status-inprogress status-btn-inprogress';
//             case 'Resolved':
//                 return 'status-approved status-btn-resolved';
//             case 'Re-Open':
//                 return 'status-reopen';
//             case 'Cancelled':
//                 return 'status-rejected status-btn-rejected';
//             default:
//                 return '';
//         }
//     };

//     // Determine whether to show the chevron
//     // const shouldShowChevron = localStatus !== 'Approved' && localStatus !== 'Rejected';

//     // Determine whether to show the chevron (Exclude "Resolved" and "Cancel" statuses)
//     const shouldShowChevron = !['Cancelled'].includes(status);

//     return (
//         <>
//             <div className="dropdown add-single-bulk">
//                 <span
//                     className={`btn status-btn dropdown-toggle ${getButtonClass()}`}
//                 >
//                     {status}
//                     {shouldShowChevron && (
//                         <span className="dropdown-arrow" data-bs-toggle="dropdown" aria-expanded="false" onClick={handleClick}>
//                             &nbsp;&nbsp;&nbsp;
//                             <img src={cheverondown} alt="dropdown-icon" />
//                         </span>
//                     )}

//                     {/* <ul className="dropdown-menu" aria-labelledby="statusDropdown">
//                         <li>
//                             <button
//                                 className="dropdown-item"
//                                 onClick={() => handleStatusChange('Pending')}
//                             >
//                                 Pending
//                             </button>
//                         </li>
//                         <li>
//                             <button
//                                 className="dropdown-item"
//                                 onClick={() => handleStatusChange('In-Process')}
//                             >
//                                 In-Process
//                             </button>
//                         </li>
//                         <li>
//                             <button
//                                 className="dropdown-item"
//                                 onClick={() => handleStatusChange('Resolved')}
//                             >
//                                 Resolved
//                             </button>
//                         </li>
//                         <li>
//                             <button
//                                 className="dropdown-item"
//                                 onClick={() => handleStatusChange('Re-Open')}
//                             >
//                                 Re-Open
//                             </button>
//                         </li>
//                         <li>
//                             <button
//                                 className="dropdown-item"
//                                 onClick={() => handleStatusChange('Cancel')}
//                             >
//                                 Cancel
//                             </button>
//                         </li>
//                     </ul> */}

//                     {/* <ul className="dropdown-menu" aria-labelledby="statusDropdown"> */}
//                     <ul className="dropdown-menu">
//                         {complaintEscalationStatusDropdownData && complaintEscalationStatusDropdownData.map((statusOption) => (
//                             <li key={statusOption.value}>
//                                 <button
//                                     className="dropdown-item"
//                                     onClick={() => handleStatusChange(statusOption.label)}
//                                 >
//                                     {statusOption.label}
//                                 </button>
//                             </li>
//                         ))}
//                     </ul>
//                 </span>
//             </div>

//             <Modal show={showModal} onHide={handleClose} className='add-customer-modal'>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Confirm {action}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     Are you sure you want to {action?.toLowerCase()} this Complaint?
//                     {action === 'Rejected' && (
//                         <div className="mt-3">
//                             <label htmlFor="rejectionReason">Reason</label>
//                             <textarea
//                                 id="rejectionReason"
//                                 className="form-control"
//                                 rows="3"
//                                 value={rejectionReason}
//                                 onChange={(e) => setRejectionReason(e.target.value)}
//                             />
//                         </div>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <SbCancelBtn btnName="No" onClickEffect={handleClose} />
//                     <SBSaveUpdateBtn btnName="Yes" onClickEffect={handleConfirm} />
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// };

// export default SbComplaintStatusDropdown;






import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/leaves.scss'; // Ensure this path is correct
import { Modal } from 'react-bootstrap';
import SbCancelBtn, { SBSaveUpdateBtn } from './Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { loadComplaintEscalationStatusDropdownData, postComplaintEscalationStatusChangeDatas } from '../../redux/action';
import { Col, Form, Row } from "react-bootstrap";
import attachmentImg from '../../assets/images/attachmentImg.svg';
import Select from 'react-select';
import '../../assets/css/dashboard.scss'
import * as HeaderAuthentication from '../HeaderAuthentication';
import { baseURL } from "../BaseUrl";
import { ADDED_BY_ID } from '../../Constants';

const SbComplaintStatusDropdown = ({ status, onStatusChange, complaintId, getComplaintData, AssignedToUserID, IsReOpen, statusId, customer, ReportedByUserID }) => {

    let dispatch = useDispatch();

    const { complaintEscalationStatusDropdownData } = useSelector((state) => state.data);
    const fileInputRef = useRef(null);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

    const [localStatus, setLocalStatus] = useState(status); // Use the prop status as initial value
    const [showModal, setShowModal] = useState(false);
    const [action, setAction] = useState(null);
    const [rejectionReason, setRejectionReason] = useState(''); // State for rejection reason
    const [selectedFile, setSelectedFile] = useState(null); // Store selected file
    const [fileError, setFileError] = useState(''); // Error for file validation
    const [statusError, setStatusError] = useState('');
    const [remarksError, setRemarksError] = useState('');
    const [statusChangeDetails, setStatusChangeDetails] = useState({
        ComplaintID: complaintId,
        StatusChangeUserUploadedFileName: '',
        StatusChangeTempFileName: '',
        StatusID: null,
        StatusChangeRemarks: '',
        AddedByID: ADDED_BY_ID,
    });

    useEffect(() => {
        if (complaintId && status) {
            setStatusChangeDetails({
                ComplaintID: complaintId,
                StatusChangeUserUploadedFileName: '',
                StatusChangeTempFileName: '',
                StatusID: status,
                StatusChangeRemarks: '',
                AddedByID: ADDED_BY_ID,
            });
        }
    }, [complaintId, status]);

    const [selectedDropdownValue, setSelectedDropdownValue] = useState(status);

    // Initialize it when status or complaintEscalationStatusDropdownData loads:
    useEffect(() => {
        if (complaintEscalationStatusDropdownData && status != null) {
            const foundOption = complaintEscalationStatusDropdownData.find(opt => opt.value === status);
            setSelectedDropdownValue(foundOption ? foundOption.value : null);
            setStatusChangeDetails(prev => ({
                ...prev,
                StatusID: status,
            }));
        }
    }, [complaintEscalationStatusDropdownData, status]);

    // Trigger file input click
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setFileError('File size must be less than 5MB.');
                setSelectedFile(null); // Reset file selection
            } else {
                setFileError(''); // Clear file error
                setSelectedFile(file);
                setStatusChangeDetails((prev) => ({
                    ...prev,
                    StatusChangeUserUploadedFileName: file.name,
                }));
                uploadFile(file);
            }
        }
    };

    // File upload function
    const uploadFile = (file) => {
        const formData = new FormData();
        formData.append("file", file); // Attach the selected file to the form data

        fetch(`${baseURL}/complaintservices/api/Complaint/UploadFile`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.excomatixAuth,
            body: formData,
        })
            .then((resp) => resp.json())
            .then((resp) => {
                //  update the TempFileName from response
                setStatusChangeDetails(prevData => ({
                    ...prevData,
                    StatusChangeTempFileName: resp // Update with the TempFileName from the response
                }));
            })
            .catch((err) => {
                console.error("File upload failed:", err);
            });
    };

    const handleStatusSelectChange = (selectedOption) => {
        setStatusError(''); // Clear status error
        setStatusChangeDetails((prev) => ({
            ...prev,
            StatusID: selectedOption.value,
        }));
    };

    const handleRemarksChange = (event) => {
        setRemarksError('');
        setStatusChangeDetails((prev) => ({
            ...prev,
            StatusChangeRemarks: event.target.value,
        }));
    };

    // const handleClick = () => {
    //     if (status === 'Cancelled') {
    //         return; // Do nothing if the status is "Cancelled"
    //     }
    //     if (AssignedToUserID === 0) {
    //         return; // Do nothing if the status is "Cancelled"
    //     }
    //     if (complaintId) {
    //         dispatch(loadComplaintEscalationStatusDropdownData(complaintId)); // Dispatch with complaintId
    //     }
    //     setShowModal(true); // Open modal when button is clicked
    // };

    const handleClick = () => {
        const roleIDs = signInDetails[0]?.RoleIDs?.split(',').map(id => id.trim()) || [];
        const signInType = signInDetails[0]?.SignInType;
        // Allow only if user has RoleID 16, 17, or 20
        // const allowedRoleIDs = ['16', '17', '20'];
        // const hasAllowedRole = roleIDs.some(role => allowedRoleIDs.includes(role)) || signInType === 'SuperAdmin';

        // if (!hasAllowedRole) {
        //     return; // Block access to modal if RoleID is not allowed
        // }
        // Block if status is 'Cancelled' or not assigned, except when status is 'Resolved' and role 17 is present
        const isResolvedWithRole17 = status === 'Resolved' && roleIDs.includes('17');

        // if ((status === 'Cancelled' || AssignedToUserID === 0) && !isResolvedWithRole17) {
        if ((status === 'Cancelled') && !isResolvedWithRole17) {
            return;
        }

        // If not role 17 and status is resolved, block
        if (status === 'Resolved' && !roleIDs.includes('17')) {
            return;
        }

        // ❌ Block if signInType is 'User' and IsReOpen is false\
        if (statusId === 67) {
            if (signInType === 'User' && IsReOpen === false) {
                return;
            }
        }

        if (complaintId) {
            dispatch(loadComplaintEscalationStatusDropdownData(complaintId));
        }

        setShowModal(true);
    };

    // useEffect(() => {
    //     if (complaintId && status) {
    //         setStatusChangeDetails((prev) => ({
    //             ...prev,
    //             StatusID: status, // Directly set the status
    //         }));
    //     }
    // }, [complaintId, status]);

    // Handle status change and show modal for certain actions
    const handleStatusChange = (newStatus) => {
        setAction(newStatus);
        setShowModal(true);
    };

    // Confirm the action and update status
    const handleConfirm = () => {
        if (action) {
            setLocalStatus(action);
            onStatusChange(action); // Update the parent status
            setAction(null);
            setRejectionReason(''); // Reset reason after confirming
        }
        setShowModal(false);
    };

    // Close the modal without updating status
    const handleClose = () => {
        setShowModal(false);
        setAction(null);
        setRejectionReason(''); // Reset reason on close
        setSelectedFile(null);
        // setStatusChangeDetails({});
        setStatusChangeDetails({
            ComplaintID: complaintId,
            StatusChangeUserUploadedFileName: '',
            StatusChangeTempFileName: '',
            StatusID: status,
            StatusChangeRemarks: '',
            AddedByID: ADDED_BY_ID,
        });
    };

    // const shouldShowInProcess =
    //     ReportedByUserID === signInDetails[0]?.UserID &&
    //     !["16", "17", "20"].some(role => signInDetails[0]?.RoleIDs?.split(',').includes(role)) &&
    //     [39, 40, 68].includes(statusId);

    // const shouldShowResolvedPendingQA = [38].includes(statusId);

    // const displayStatus = shouldShowInProcess ? 'In-Process' : (shouldShowResolvedPendingQA ? 'Resolved-Pending QA' : status);

    const user = signInDetails[0] || {};
    const userRoles = user.RoleIDs?.split(',') || [];
    const isInternalRole = ["16", "17", "20"].some(role => userRoles.includes(role));

    const shouldShowInProcess =
        (
            (ReportedByUserID === user.UserID && !isInternalRole) ||
            user.SignInType === "ClientAdmin"
        ) &&
        [39, 40, 68].includes(statusId);

    const shouldShowResolvedPendingQA = statusId === 38;

    const displayStatus = shouldShowInProcess
        ? 'In-Process'
        : shouldShowResolvedPendingQA
            ? 'Resolved-Pending QA'
            : status;

    // Determine the button class based on status
    const getButtonClass = () => {
        // switch (status) {
        switch (displayStatus) {
            case 'Pending':
                return 'status-pending status-btn-pending';
            case 'In-Process':
                return 'status-inprogress status-btn-inprogress';
            case 'Resolved-Pending QA':
                return 'status-resolved status-btn-resolved';
            case 'Re-Open':
                return 'status-reopen status-btn-reopen';
            case 'Cancelled':
                return 'status-rejected status-btn-rejected';
            case 'Rejected':
                return 'status-rejected status-btn-rejected';
            case 'Unable To Resolve':
                return 'status-unable-to-resolve status-btn-rejected';
            case 'Completed':
                // return 'status-closed status-btn-closed'
                return 'status-approved status-btn-resolved'
            default:
                return '';
        }
    };

    const validateForm = () => {
        let isValid = true;
        console.log("Validating StatusID:", statusChangeDetails.StatusID);
        // Validate Status selection
        if (!statusChangeDetails.StatusID) {
            console.log("Status validation failed");
            setStatusError('Status is required.');
            isValid = false;
        } else {
            setStatusError('');
        }

        // Validate Remarks field separately
        if (!statusChangeDetails.StatusChangeRemarks.trim()) {
            setRemarksError('Remarks are required.');
            isValid = false;
        } else {
            setRemarksError('');
        }

        // Validate file size if a file is selected
        if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
            setFileError('File size must be less than 5MB.');
            isValid = false;
        } else {
            setFileError('');
        }

        return isValid;
    };

    const addStatusChangeData = (e) => {

        if (!validateForm()) {
            return; // Stop submission if validation fails
        }

        const roleIDs = signInDetails[0]?.RoleIDs?.split(',').map(id => id.trim()) || [];
        const isQAUser = roleIDs.includes('17');

        const selectedOption = complaintEscalationStatusDropdownData.find(opt => opt.value === statusChangeDetails.StatusID);

        let statusIdToSend = statusChangeDetails.StatusID;

        if (isQAUser && selectedOption?.label === 'Re-Open') {
            statusIdToSend = 37;
        }

        const requestBody = {
            ...statusChangeDetails,
            StatusID: statusIdToSend,
        };

        e.preventDefault();
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(requestBody),
        };
        dispatch(postComplaintEscalationStatusChangeDatas(requestOption, handleClose, getComplaintData));
        // console.log(statusChangeDetails, 'statusChangeDetails')
    }

    return (
        <>
            <div className="dropdown add-single-bulk">
                <span
                    className={`btn status-btn ${getButtonClass()}`} // No dropdown-toggle class
                    onClick={handleClick} // Open modal on click
                >
                    {/* {status} */}
                    {displayStatus}
                </span>
            </div>

            <Modal show={showModal} onHide={handleClose} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Status (SR No:{complaintId})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <div>
                                <label className='pt-2 pb-2'>Status<span className="required-asterisk">*</span></label>
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={complaintEscalationStatusDropdownData}
                                    placeholder="Select Status"
                                    value={
                                        complaintEscalationStatusDropdownData.find(
                                            (option) => option.value === statusChangeDetails.StatusID
                                        ) || null // Default to null if no match is found
                                    }
                                    onChange={handleStatusSelectChange}
                                />
                            </div>
                            {statusError && (
                                <div className="text-danger">
                                    <small>{statusError}</small>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label className='pt-2 pb-2'>Remarks <span className="required-asterisk">*</span></label>
                                <Form.Control
                                    as="textarea"
                                    type="text"
                                    rows={3}
                                    value={statusChangeDetails.StatusChangeRemarks}
                                    onChange={handleRemarksChange}
                                />
                                {remarksError && (
                                    <div className="text-danger">
                                        <small>{remarksError}</small>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="d-flex justify-content-start align-items-end">
                            {/* Attachment Section */}
                            <div className="dropdown add-single-bulk attachment-section">
                                <button className="btn btn-add-save-update attachment-btn" onClick={handleAttachmentClick}>
                                    <img src={attachmentImg} alt="" />&nbsp;&nbsp;
                                    <span>Attachment</span>
                                    <div className="attachment-note">
                                        <small>(jpg, PDF, word doc) Less than 5MB</small>
                                    </div>
                                </button>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                            </div>
                        </Col>
                        {fileError && (
                            <Row>
                                <Col md={12}>
                                    <div className="text-danger mt-2">
                                        <small>{fileError}</small>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        {selectedFile && !fileError && (
                            <Row>
                                <Col md={12}>
                                    <div className="attachment-note mt-2">
                                        <small>Selected File: {selectedFile.name}</small>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="No" onClickEffect={handleClose} />
                    <SBSaveUpdateBtn btnName="Yes" onClickEffect={addStatusChangeData} />
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default SbComplaintStatusDropdown;
